import React from 'react';
import './UserAvatar.css';
import { UserHelper } from 'view/helpers';

const UserAvatar = ({
	user,
	size = 'medium',
	showTooltip = true,
	tooltipPlacement = 'top',
	style = {},
	onClick,
	className = '',
}) => {
	const avatarStyle = {
		backgroundColor: UserHelper.getAvatarColor(user.name || user.email),
		color: '#ffffff',
		fontWeight: '600',
		cursor: onClick ? 'pointer' : 'default',
		border: 'none',
		transition: 'transform 0.2s ease, box-shadow 0.2s ease',
		...style,
	};

	const handleMouseEnter = (e) => {
		e.currentTarget.style.transform = 'scale(1.1)';
		e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
	};

	const handleMouseLeave = (e) => {
		e.currentTarget.style.transform = 'scale(1)';
		e.currentTarget.style.boxShadow = 'none';
	};

	if (showTooltip && user.name) {
		return (
			<div
				className={`user-avatar user-avatar-${size} ${className}`}
				style={avatarStyle}
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
				onClick={onClick}
				title={user.name}
			>
				{UserHelper.getShortName(user.name)}
			</div>
		);
		// return (
		// 	<CustomTooltip
		// 		content={user.name}
		// 		placement={tooltipPlacement}
		// 		delay={100}
		// 		id={`user-avatar-tooltip-${user.id}`}
		// 	>
		// 		<div
		// 			className={`user-avatar user-avatar-${size} ${className}`}
		// 			style={avatarStyle}
		// 			onMouseEnter={handleMouseEnter}
		// 			onMouseLeave={handleMouseLeave}
		// 			onClick={onClick}
		// 		>
		// 			{getInitials(user.name)}
		// 		</div>
		// 	</CustomTooltip>
		// );
	}

	return (
		<div
			className={`user-avatar user-avatar-${size} ${className}`}
			style={avatarStyle}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			onClick={onClick}
			title={user.name}
		>
			{UserHelper.getShortName(user.name)}
		</div>
	);
};

export default UserAvatar;
